import axios from 'axios';
/**
 * Клиент API для эндпоинта GET /rest/api/v1/tags/{tagId}/articles.
 * Эндпоинт публичный — аутентификация не требуется.
 * Зеркалирует CategoryArticlesApi.
 */
export class TagArticlesApi {
    async getArticles(tagId, params = {}) {
        const { page = 1, size } = params;
        const queryParams = {
            page: String(page),
        };
        if (size != null) {
            queryParams.size = String(size);
        }
        const response = await axios.get(`/rest/api/v1/tags/${tagId}/articles`, { params: queryParams });
        return response.data;
    }
}
